import View from 'views/base/view';
import $ from 'jquery';
import BrowserCourseEditorTemplate from 'views/browser-course-editor/templates/browser-course-editor';
import { gsap } from 'gsap/dist/gsap';
import { Draggable } from 'gsap/dist/Draggable';
import yaml from 'js-yaml';
import DOMPurify from 'dompurify';
import ExporterView from 'views/exporter/exporter-view';

const BrowserCourseEditor = View.extend({
  template: BrowserCourseEditorTemplate,
  container: '#site-container',
  autoRender: true,
  autoAttach: true,
  regions: {
    exporter: '#exporter-holder',
  },
  listen: {
    addedToDOM: 'loaded',
  },
  loaded: function () {
    gsap.registerPlugin(Draggable);
    this.howToSubmitVal = 'direct';
    this.operationVal = 'replace';
    this.$editorHolder = $('#browser-editor-holder');
    this.$editor = $('#browser-course-editor');
    this.$editorHandle = $('#editor-handle');
    this.setDrag();
    this.setListeners();
    const exporterView = new ExporterView({
      region: 'exporter',
    });
    this.subview('exporterView', exporterView);
  },
  setDrag: function () {
    Draggable.create(this.$editorHolder, {
      autoScroll: true,
      allowEventDefault: true,
      trigger: '#editor-handle',
    });
  },
  getErrorBlock: function (msg) {
    return [{
      type: 'text',
      items: [{description: msg}],
    }];
  },
  setListeners: function () {
    this.$editor.find('#localeBtn').click(evt => {
      const sanitizedValue = DOMPurify.sanitize(this.$editor.find('#ymlInput').val());
      const msg = {
        locale: yaml.load(sanitizedValue),
        sender: 'browserEditor',
      };
      parent.postMessage(msg, window.location.origin);
    });
    this.$editor.find('#resetBtn').click(evt => {
      this.$editor.find('#ymlInput').val('');
    });
    this.$editor.find('#submitBtn').click(evt => {
      const sanitizedValue = DOMPurify.sanitize(this.$editor.find('#ymlInput').val());
      let curBlockModelObj, curAtomModelObj;
      if (this.currentAtomModel) {
        curBlockModelObj = yaml.load(this.currentBlockModel);
        curAtomModelObj = yaml.load(sanitizedValue);
        Object.assign(curBlockModelObj.blocks[0]['module-content'][curAtomModelObj.atomType], curAtomModelObj);
      } else {
        curBlockModelObj = yaml.load(sanitizedValue);
      }
      const msg = {
        model: curBlockModelObj,
        xpath: this.current_xpath,
        operation: this.operationVal,
      };
      parent.postMessage(msg, window.location.origin);
    });

    this.$editor.find('#howToSubmit').change(evt => {
      this.howToSubmitVal = this.$editor.find('#howToSubmit').val().toLowerCase();
    });
    this.$editor.find('#operation').change(evt => {
      this.operationVal = this.$editor.find('#operation').val().toLowerCase();
    });

    $('#ymlInput').on('input', evt => {
      let curBlockModelObj, curAtomModelObj;
      const sanitizedValue = DOMPurify.sanitize(this.$editor.find('#ymlInput').val());
      if (this.currentAtomModel) {
        curBlockModelObj = yaml.load(this.currentBlockModel);
        curAtomModelObj = yaml.load(sanitizedValue);
        Object.assign(curBlockModelObj.blocks[0]['module-content'][curAtomModelObj.atomType], curAtomModelObj);
      } else {
        curBlockModelObj = yaml.load(sanitizedValue);
      }
      if (this.howToSubmitVal === 'direct') {
        const msg = {
          model: curBlockModelObj,
          xpath: this.current_xpath,
          operation: this.operationVal,
        };
        parent.postMessage(msg, window.location.origin);
      }
    });
    this.setPostMessage();
  },
  setPostMessage: function () {
    parent.addEventListener('message', evt => {
      if (evt.data.detail) {
        this.current_xpath = evt.data.detail.xpath;
        if (evt.data.detail.atomModel) {
          this.$editor.find('#ymlInput').val(evt.data.detail.atomModel);
          this.currentAtomModel = evt.data.detail.atomModel;
        } else {
          this.$editor.find('#ymlInput').val(evt.data.detail.model);
          this.currentAtomModel = null;
        }
        this.currentBlockModel = evt.data.detail.model;
      }
    });
  },
});
export default BrowserCourseEditor;
